import PropTypes from 'prop-types';
import React from 'react';
import entityComposition from '../../common/classes/entityComposition';
import valueSelector from '../selectors/valueSelector';
const HeaderBar = ({
  className: _className = '',
  value: _value = null
}) => {
  if (!_value) return null; // don't render anything if the value is not set

  const headerStyle = {
    backgroundColor: 'grey',
    color: '#fff',
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
    padding: '10px'
  };
  return /*#__PURE__*/React.createElement("h2", {
    style: headerStyle,
    className: `m-n5 t-hb ${_className}`
  }, _value);
};
HeaderBar.propTypes = {
  className: PropTypes.string,
  format: PropTypes.shape({
    value: PropTypes.string
  }),
  value: PropTypes.string
};
export { HeaderBar as UncomposedHeaderBar };
export default entityComposition(HeaderBar, [], {
  value: valueSelector
});